import { buildArtistHubJsonLd } from "@/features/artist-hub/artist-hub-json-ld";
import { alternatesToLinks, buildLocalizedPageAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import type { RouterOutputs } from "@/types/rpc";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

type ArtistHub = RouterOutputs["featurePages"]["getArtistHub"];

export async function buildArtistHubHead(input: {
  locale: ViewerLocale;
  title: string;
  description: string;
  hub: ArtistHub | undefined;
}) {
  const alternates = buildLocalizedPageAlternates(input.locale, "artists");
  const jsonLd = buildArtistHubJsonLd({
    locale: input.locale,
    title: input.title,
    description: input.description,
    directories: input.hub?.directories ?? [],
  });

  return {
    meta: await buildPagePreviewMetaTags(
      {
        title: input.title,
        description: input.description,
        canonicalUrl: alternates.canonical,
      },
      {
        robots: "index,follow",
        openGraph: { type: "website" },
        twitter: {},
      },
      { locale: input.locale },
    ),
    links: alternatesToLinks(alternates),
    scripts: [{ type: "application/ld+json", children: JSON.stringify(jsonLd) }],
  };
}
